<template>
  <div class="courier-delivery-page transport-courier-delivery-page">
    <div class="banner-wrapper">
      <div class="banner">
        <header-menu style="position: relative" />
        <div class="banner-body">
          <div>
            <div class="banner-body-title">
              <strong class="banner-data-label">Курьерская доставка</strong>
            </div>
            <div class="banner-body-description">
              <p>Отправляйте и получайте так, как удобно</p>
              <p>Передайте отправление курьеру или самостоятельно привезите его на терминал компании «Транспортные технологии».</p>
              <p>Получатель сможет забрать отправление на терминале компании «Транспортные технологии», в ПВЗ Яндекса или заказать доставку по адресу.</p>
            </div>

            <div class="banner-body-data">
              <div
                v-for="item in featureItems"
                :key="item.title"
              >
                <img :src="item.icon">
                <div>{{ item.title }}</div>
                <span>{{ item.description }}</span>
              </div>
            </div>
          </div>
          <t-calculator
            id="courier-delivery-calculator"
            ref="calculator"
            class="calculator"
            is-courier-delivery
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ref} from 'vue'
import TCalculator from '@/components/TCalculator.vue'
import HeaderMenu from '@/components/HeaderMenu.vue'

const featureItems = [
  {
    icon: require('@/assets/icons/check.svg'),
    title: 'Курьер или терминал',
    description: 'Передайте отправление удобным способом'
  },
  {
    icon: require('@/assets/icons/point.svg'),
    title: 'До двери, терминала или ПВЗ',
    description: 'Получатель сам выбирает удобный вариант'
  },
  {
    icon: require('@/assets/icons/search-check.svg'),
    title: 'Отслеживание на всём пути',
    description: 'Статус отправления доступен онлайн'
  }
]

export default {
  name: 'TransportCourierDeliveryBanner',
  components: {
    HeaderMenu,
    TCalculator
  },
  setup(_, {expose}) {
    const calculator = ref(null)

    function setDirection(item) {
      calculator.value?.setDirection(item)
    }

    expose({
      setDirection
    })

    return {
      calculator,
      featureItems
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/banner.css";

$pub-md: 1239px;

.courier-delivery-page {
  font-family: 'Roboto', sans-serif;

  :deep(.calculator) {
    width: 420px;
    max-width: 100%;
    box-sizing: border-box;
    flex-shrink: 0;
    border-color: white;
    border-radius: 0;
  }

  :deep(.calculator) h2 {
    font-size: 26px;
    line-height: 36px;
    text-transform: uppercase;
  }

  :deep(.menu-wrapper-header-title) {
    color: white;
  }

  .banner-body-title {
    :deep(.banner-data-label) {
      display: inline-block;
      margin: 40px 0 40px -190px;
      padding: 33px 68px 33px 190px;
      font-size: min(11vw, 42px);
      line-height: 100%;
      font-weight: 600;
      font-family: 'Open Sans', sans-serif;
      color: white;
      background-color: var(--primary-color);
      text-align: left;
      text-transform: uppercase;
    }

    :deep(strong::after) {
      display: none;
    }
  }
}

.banner-wrapper {
  position: relative;
  background-image: url("../../assets/images/transport_technology.jpg");
  background-size: cover;
  background-position: center;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    opacity: 0.94;
    background-color: #0C1323;
  }

  * {
    z-index: 1;
  }

  .banner-body {
    position: relative;
    color: white;
    margin-bottom: unset;
    border: 1px solid white;
    padding-left: 50px;
    column-gap: 50px;

    > div:first-child {
      padding: 0 20px;
    }
  }
}

.banner-body-title {
  margin-top: 0;
  line-height: 48px;
}

.banner-body-description {
  width: 100%;
  max-width: unset;

  p {
    &:first-child {
      font-size: 22px;
      margin: 0;
      line-height: 42px;
    }

    &:not(:first-child) {
      font-size: 16px;
      margin: 5px 0 0 0;
      line-height: 26px;
    }
  }
}

.banner {
  max-width: 1240px;
  width: 97%;
  margin-left: auto;
  margin-right: auto;
  padding-bottom: 40px;
}

.banner-body-data {
  width: 100%;
  max-width: none;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 40px;
  margin-top: 40px;

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    font-size: 14px !important;

    > div {
      font-size: 14px;
    }
  }
}

@media screen and (max-width: $pub-md - 1) {
  .banner-body {
    flex-direction: column;
    margin-top: 60px;
    gap: 55px;
    padding-left: 0;

    &-title {
      margin-top: 0;

      :deep(.banner-data-label) {
        width: fit-content;
        display: block;
        padding-left: 240px;
      }
    }
  }

  .banner-wrapper {
    .banner-body {
      padding-left: 0;
    }
  }

  .courier-delivery-page {
    :deep(.calculator) {
      width: 100%;
    }
  }
}

@media screen and (max-width: 768px) {
  .banner-body {
    flex-direction: column;
    margin-top: 40px;
  }

  .courier-delivery-page {
    .banner-body-title {
      :deep(.banner-data-label) {
        width: 100%;
        margin-left: -31px;
        margin-right: 0;
        padding-left: 31px;
        padding-right: 31px;
      }
    }
  }
}

@media screen and (max-width: 420px) {
  .banner {
    padding-bottom: unset;
    margin-bottom: 600px;
  }

  .courier-delivery-page {
    :deep(.calculator) {
      margin-bottom: -500px;
    }
  }

  .banner-body-data {
    grid-template-columns: 1fr;
  }

  .courier-delivery-page {
    .banner-body-title {
      :deep(.banner-data-label) {
        width: 100%;
        margin-left: -25px;
        margin-right: 0;
        padding-left: 25px;
        padding-right: 25px;
      }
    }
  }
}
</style>
